import IdleTimer from './IdleTimer';

export { LAST_ACTIVITY_TIME_KEY } from './constants';
export default IdleTimer;
